<template>
  <div id="">
    <div class="container mt-4">
      <div id="data-list-list-view" class="data-list-container b-card">
        <b-overlay :show="isOverviewLoading" rounded="sm">
          <b-card class="card-statistics" style="padding: 0; margin: 0">
            <b-card-header class="p-0">
              <b-card-title><h3>Overview</h3></b-card-title>
            </b-card-header>
            <b-card-body class="m-0 p-0">
              <div class="d-flex flex-row flex-wrap">
                <b-col
                  v-for="item in statistics"
                  :key="item.icon"
                  class="mb-md-0 w-100 d-flex"
                  :class="item.color"
                >
                  <div class="d-flex flex-row flex-gap-sm w-100">
                    <div class="">
                      <b-avatar size="64" :variant="item.color">
                        <feather-icon size="48" :icon="item.icon" />
                      </b-avatar>
                    </div>
                    <div class="w-100">
                      <b-card-text class="mb-0">
                        <h4 class="font-weight-bolder">
                          {{ item.stats }}
                        </h4>
                      </b-card-text>
                      <p class="">
                        {{ item.title }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </div>
            </b-card-body>
          </b-card>
        </b-overlay>
        <b-overlay :show="isTableLoading" rounded="sm" class="mt-1">
          <b-card id="jobs-table" class="w-100 p-0 m-0">
            <h4 class="">Select any video below to analyse</h4>

            <vue-good-table
              class="mt-1"
              theme="polar-bear"
              mode="remote"
              :columns="insightColumns"
              :rows="insights"
              :total-rows="totalRecords"
              :select-options="{
                enabled: true,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: false, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }"
              :pagination-options="{
                enabled: true,
                perPage: serverParams.perPage,
                perPageDropdown: [5, 10, 20, 50, 100],
                dropdownAllowAll: false,
              }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              @on-selected-rows-change="onSelectionChange"
            >
              <template slot="column-filter" slot-scope="props">
                <!-- <span
                v-if="props.column.field === 'interview'"
              >

                <v-select
                  :options="interviewOptions"
                  class=""
                  @input="onJobColumnFilter($event, props)"
                />
              </span> -->
              </template>

              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'actions'">
                  <div class="self-center">
                    <div class="d-flex flex-wrap flex-gap-xs">
                      <!-- View -->
                      <b-button
                        v-b-tooltip.hover.top="
                          'Click here to view Applications'
                        "
                        class="btn-icon small-space"
                        variant="outline-dark"
                        @click="goToInsightDetails(props.row.meeting_id)"
                      >
                        <!-- @click="goToInsightDetails(props.row.meeting_id)" -->
                        <feather-icon
                          icon="EyeIcon"
                          svg-classes="hover:text-primary stroke-current"
                        />
                      </b-button>

                      <!-- Edit -->
                      <!-- <b-button
                        v-if="$checkRights($route.meta.section, 'update')"
                        v-b-tooltip.hover.top="'Edit this job'"
                        class="btn-icon small-space"
                        variant="outline-dark"
                        @click="editATSJob(props.row)"
                      >
                        <feather-icon
                          icon="EditIcon"
                          svg-classes="hover:text-primary stroke-current"
                        />
                      </b-button> -->
                    </div>
                  </div>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
// import "video.js/dist/video-js.css"

// import { videoPlayer } from "vue-video-player"
import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  VBModal,
  BBadge,
  BAvatar,
  BOverlay,
  BFormCheckbox,
  BFormInvalidFeedback,
} from "bootstrap-vue"
import { VueGoodTable } from "vue-good-table"

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    VBModal,
    BBadge,
    BAvatar,
    BOverlay,
    BFormCheckbox,
    BFormInvalidFeedback,
    // videoPlayer,
    VueGoodTable,
  },

  data() {
    return {
      isOverviewLoading: false,
      isTableLoading: false,
      statistics: [
        {
          title: "Finished Interviews",
          stats: 0,
          icon: "CheckIcon",
          color: "light-success",
        },
        {
          title: "Pending Interviews",
          stats: 0,
          icon: "VideoIcon",
          color: "light-warning",
        },
        {
          title: "Average Interview Time",
          stats: 0,
          icon: "ClockIcon",
          color: "light-success",
        },
      ],
      items_deletion: [],
      selectedRows: null,
      action_view: "dark",
      action_text: "Actions",
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      insightColumns: [
        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "",
            trigger: "enter",
          },
          sortable: false,
        },
        {
          label: "Meeting ID",
          field: "meeting_id",
          filterOptions: {
            enabled: true,
            placeholder: "",
            trigger: "enter",
          },
          sortable: false,
        },
        {
          label: "Meeting Time",
          field: "interview_date_time",
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: "",
            trigger: "enter",
          },
        },
        {
          label: "Candidate Name",
          field: "fullname",

          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: "",
            trigger: "enter",
          },
        },
        {
          label: "Position",
          field: "position",
          filterOptions: {
            enabled: true,
            placeholder: "",
            trigger: "enter",
          },
        },
        // {
        //   label: 'Interview Enabled',
        //   field: 'interview',
        //   filterOptions: {
        //     enabled: false,
        //     placeholder: '',
        //     trigger: 'enter',
        //   },
        // },
      ],
      insights: [
        // {
        //   meeting_id: uuid(),
        //   meeting_time: new Date(),
        //   candidate_name: "Asdf",
        //   position: "Full Stack Developer",
        // },
        // {
        //   meeting_id: uuid(),
        //   meeting_time: new Date(),
        //   candidate_name: "qwer",
        //   position: "Full Stack Developer",
        // },
      ],
      totalRecords: 2,
      // show_videos: false,
      // all_videos: [],
      // selected_video: "",
      // overall_attention: 0,
      // overall_emotion: "Calculating..",
      // valence: "Calculating..",
      // likely_age: 0,
      // total_attention: [],
      // emotion_loading: true,
      // emotion_data: "",
      // // emotion_data: [{ "name": "Tiredness", "score": 0.5671913628257922 }, { "name": "Calmness", "score": 0.39939376355996775 }, { "name": "Disappointment", "score": 0.38397228006106704 }, { "name": "Boredom", "score": 0.3698303583842605 }, { "name": "Sadness", "score": 0.35037813791588174 }],
      // emotion: {
      //   happy: 0,
      //   fear: 0,
      //   disgust: 0,
      //   sad: 0,
      //   surprise: 0,
      //   angry: 0,
      //   neutral: 0,
      // },
      // attention: 0,
      // morphCast: undefined,
      // video_active: true,
      // video_link: "",
      // itemsPerPage: 4,
      // products: [],
      // isMounted: false,
      // playerOptions: {
      //   // videojs options
      //   crossOrigin: "Anonymous",
      //   controls: true,
      //   liveui: true,
      //   muted: true,
      //   language: "en",
      //   playbackRates: [0.7, 1.0, 1.5, 2.0, 2.5, 3.0],
      //   width: 800,
      //   height: 500,
      //   sources: [
      //     {
      //       type: "video/mp4",
      //       src: "",
      //       // src: this.$http.defaults.baseURL + "/api/media/interview_place.mp4",
      //     },
      //   ],
      //   // poster: "https://goo.gl/xcCsDd",
      //   isLoading: true,
      // },
    }
  },
  // computed: {
  //   player() {
  //     return this.$refs.videoPlayer.player
  //   },
  //   currentPage() {
  //     if (this.isMounted) {
  //       return this.$refs.table.currentx
  //     }
  //     return 0
  //   },

  //   queriedItems() {
  //     return this.$refs.table
  //       ? this.$refs.table.queriedResults.length
  //       : this.all_videos.length
  //   },
  // },
  created() {
    // this.video_link = await this.$generateDownloadUrl(
    //   "media/interview_sample.mp4"
    // )
    // this.playerOptions.sources = [
    //   {
    //     type: "video/mp4",
    //     // src: await this.$generateDownloadUrl('media/interview_tips.mp4'),
    //     src: this.video_link,
    //     // src: this.$http.defaults.baseURL + "/api/media/interview_place.mp4",
    //   },
    // ]
    // const { user_group } = this.$store.state.auth.ActiveUser
    // this.get_all_videos()

    this.getMeetings()
    this.getMeetingsOverview()
  },
  mounted() {
    // console.log("mounted")
    // this.detect_emotion()
    // if (!this.show_videos) {
    //   // this.loadAnalyzer()
    // }
  },
  methods: {
    goToInsightDetails(meeting_id) {
      this.$router.push(`/events-manager/insight-details/${meeting_id}`)
    },
    async getMeetingsOverview() {
      this.isOverviewLoading = true

      try {
        const getResponse = await this.$http.get("/api/meetings-overview")
        const responseData = getResponse.data.result

        this.statistics[0].stats = responseData.finished_interview
        this.statistics[1].stats = responseData.pending_interview
        this.statistics[2].stats = responseData.average_interview_time
      } catch (error) {
        // show error dialog
        this.$toastDanger(
          "An Error Occured",
          "An error occured while fetching data, please try again!"
        )
      }

      this.isOverviewLoading = false
    },
    async getMeetings() {
      this.isTableLoading = true

      try {
        const getResponse = await this.$http.get(
          `/api/meetings?query=${JSON.stringify(this.serverParams)}`
        )
        const meetingsResponse = getResponse.data

        this.totalRecords = meetingsResponse.totalRecords
        this.insights = meetingsResponse.records
      } catch (error) {
        // show error dialog
        this.$toastDanger(
          "An Error Occured",
          "An error occured while fetching data, please try again!"
        )
      }

      this.isTableLoading = false
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
      // this.getJobs()
      this.getMeetings()
      this.getMeetingsOverview()
    },
    onPageChange(params) {
      const prevSelectedROws = this.selectedRows
      this.updateParams({ page: params.currentPage })
      this.updateParams({ selectedRows: prevSelectedROws })
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
    },
    onSortChange(params) {
      if (params[0]) {
        const fieldName = params[0].field
        const sortDetails = {}
        sortDetails[fieldName] = params[0].type
        this.updateParams({ sort: sortDetails })
      }
    },
    onColumnFilter(params) {

      this.serverParams.page = 1
      this.updateParams(params)
    },
    onSelectionChange(params) {
      this.selectedRows = params.selectedRows
      this.serverParams.selectedAllRows = false
    },
    // getBack() {
    //   this.show_videos = false
    // },
    // getRecording(filename) {
    //   this.loadAnalyzer()
    //   const url = `${this.$http.defaults.baseURL}/api/recordings/`
    //   // let url = "http://localhost:81/api/recordings/"
    //   // this.video_link = url + filename;
    //   this.show_videos = false
    // },
    // get_all_videos() {
    //   this.isLoading = true
    //   this.$http
    //     .get("/api/get_recordings")
    //     .then((response) => {
    //       this.all_videos = response.data.output
    //       this.isLoading = false
    //     })
    //     .catch((error) => {})
    // },
    // detect_video() {
    //   try {
    //     CY.loader()
    //       .licenseKey("f557157399652b4555239c78e7aa4b57e758f4bdd367")
    //       .addModule(CY.modules().FACE_DETECTOR.name)
    //       .load()
    //       .then(({ start, stop }) => start())

    //     window.addEventListener(CY.modules().FACE_DETECTOR.eventName, (evt) => {
    //       // console.log("Face detector result", evt.detail);
    //     })
    //   } catch (error) {}
    // },
    // loadAnalyzer() {
    //   const morphScript = document.createElement("script")
    //   // let player = this.$refs.videoPlayer.player;
    //   Number.prototype.round = function (places) {
    //     return +`${Math.round(`${this}e+${places}`)}e-${places}`
    //   }
    //   morphScript.setAttribute(
    //     "src",
    //     "https://ai-sdk.morphcast.com/v1.14/ai-sdk.js"
    //   )
    //   morphScript.onload = () => {
    //     // player.tech_.el_.setAttribute("crossorigin", "anonymous");
    //     this.morphCast = CY
    //     const customSource = CY.createSource.fromVideoElement(
    //       document.getElementById("yt_player")
    //     )
    //     const config = { smoothness: 0.4, enableBalancer: false }
    //     this.morphCast
    //       .loader()
    //       .licenseKey("insert-here-your-license-key")
    //       .source(customSource)
    //       .addModule(CY.modules().FACE_AGE.name, {})
    //       .addModule(CY.modules().FACE_EMOTION.name, config)
    //       .addModule(CY.modules().FACE_AROUSAL_VALENCE.name, {
    //         smoothness: 0.7,
    //       })
    //       .addModule(CY.modules().FACE_ATTENTION.name, { smoothness: 0.83 })
    //       .load()
    //       .then(({ start }) => {
    //         start()
    //       })

    //     window.addEventListener(CY.modules().FACE_AGE.eventName, (evt) => {
    //       this.likely_age = evt.detail.output.numericAge
    //     })
    //     window.addEventListener(CY.modules().FACE_EMOTION.eventName, (evt) => {
    //       const { emotion } = evt.detail.output
    //       this.emotion = {
    //         angry: (emotion.Angry * 100).round(2),
    //         disgust: (emotion.Disgust * 100).round(2),
    //         surprise: (emotion.Surprise * 100).round(2),
    //         sad: (emotion.Sad * 100).round(2),
    //         happy: (emotion.Happy * 100).round(2),
    //         fear: (emotion.Fear * 100).round(2),
    //         neutral: (emotion.Neutral * 100).round(2),
    //       }
    //       // console.log(evt.detail.output);
    //       this.overall_emotion = evt.detail.output.dominantEmotion
    //     })

    //     window.addEventListener(
    //       CY.modules().FACE_ATTENTION.eventName,
    //       (evt) => {
    //         // console.log(evt.detail.output.attention);
    //         this.attention = (evt.detail.output.attention * 100).round(2)
    //         this.total_attention.push(this.attention)
    //         const average = (list) =>
    //           list.reduce((prev, curr) => prev + curr) / list.length
    //         this.overall_attention = average(this.total_attention).round(2)
    //       }
    //     )
    //     window.addEventListener(
    //       CY.modules().FACE_AROUSAL_VALENCE.eventName,
    //       (evt) => {
    //         const valence = evt.detail.output.arousalvalence
    //         if (valence > 0) {
    //           this.valence = "Positive"
    //         } else {
    //           this.valence = "Negative"
    //         }
    //       }
    //     )
    //   }

    //   document.head.appendChild(morphScript)
    // },
    // async detect_emotion() {
    //   const link = await this.$generateDownloadUrl("media/interview_sample.mp4")
    //   const encoded_link = encodeURIComponent(link)

    //   this.$http
    //     .get("/api/get-emotion-from-video?url=" + encoded_link)
    //     .then((response) => {
    //       const res = response.data.top_emotions
    //       this.emotion_loading = false
    //       this.emotion_data = res
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.card-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  overflow-x: auto;
  padding: 10px 0;
}

.emotion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 110px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  transition: transform 0.2s, box-shadow 0.2s;
}

.emotion-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.emotion-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.emotion-score {
  font-size: 22px;
  color: #4a86e8;
  font-weight: bold;
}

.emotion-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-left-color: #4a86e8;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
